import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { X } from 'lucide-react'
import { supabase } from '../lib/supabase'
import { useAccount } from '../lib/account'

export default function CrewTaxClassificationBanner() {
  const { account, country, reload } = useAccount()
  const navigate = useNavigate()
  const [dismissing, setDismissing] = useState(false)

  if (country !== 'us') return null
  if (!account) return null
  if (account.crew_tax_classification_confirmed_at) return null

  async function dismiss() {
    if (!account) return
    setDismissing(true)
    const { error } = await supabase
      .from('accounts')
      .update({ crew_tax_classification_confirmed_at: new Date().toISOString() })
      .eq('id', account.id)
    if (error) {
      console.error('Failed to dismiss banner:', error)
      setDismissing(false)
      return
    }
    await reload()
  }

  return (
    <div className="mb-4 rounded-lg border border-[var(--color-info-border)] bg-[var(--color-info-bg)] px-4 py-3 flex items-center gap-3 flex-wrap">
      <div className="flex-1 min-w-[240px]">
        <p className="text-sm font-medium text-[var(--color-info)]">Set up contractor tax classification for 1099-NEC reporting.</p>
        <p className="text-xs text-[var(--color-text-dim)] mt-0.5">Mark each contractor as 1099-NEC or W-2 so you can export year-end filings.</p>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => navigate('/crew')}
          className="text-sm px-3 py-1.5 rounded-md bg-[var(--color-info-solid)] text-[var(--color-on-solid)] font-medium hover:opacity-90"
        >
          Set up now
        </button>
        <button
          onClick={dismiss}
          disabled={dismissing}
          aria-label="Dismiss"
          className="p-1.5 rounded-md text-[var(--color-text-dim)] hover:bg-[var(--color-card)] disabled:opacity-50"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  )
}
